function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Photo from '../../../../../model/Photo';
import './View.css';

var PhotoPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(PhotoPanel, _React$Component);

  function PhotoPanel(props) {
    var _this;

    _classCallCheck(this, PhotoPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhotoPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "retrievePhoto", function () {
      clearTimeout(_this.retrieveTimeout);
      _this.retrieveTimeout = setTimeout(function () {
        var _this$props$data = _this.props.data,
            storage = _this$props$data.storage,
            photo = _this$props$data.photo;

        if (!_this._mounted) {
          return;
        }

        photo.data(storage).then(function (imageData) {
          if (_this._mounted) {
            _this.setState({
              imageData: imageData
            });
          }
        }).catch(function (error) {
          console.error("Unable to retrieve image data for photo ".concat(photo.id));
        });
      }, 100);
    });

    _this.state = {
      imageData: undefined
    };
    return _this;
  }

  _createClass(PhotoPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      this.retrievePhoto();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var retrievePhoto = this.retrievePhoto;

      if (this.props.data !== prevProps.data || this.props.data && prevProps.data && this.props.data.id !== prevProps.data.id) {
        retrievePhoto();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var imageData = this.state.imageData;
      var _this$props$data2 = this.props.data,
          photo = _this$props$data2.photo,
          toggleModal = _this$props$data2.toggleModal;
      return React.createElement("div", {
        className: "carousel-photo-view",
        key: photo.id,
        onClick: function onClick(e) {
          return toggleModal(photo.id);
        },
        style: {
          height: "".concat(innerHeight - 65 - 35, "px"),
          width: "".concat(innerWidth, "px")
        }
      }, (photo.imageData || imageData) && React.createElement("img", {
        src: "data:image/jpeg;base64,".concat(photo.imageData || imageData)
      }));
    }
  }]);

  return PhotoPanel;
}(React.Component);

export default PhotoPanel;